export const RECEIVED_CURRENT_INVOICE_ID = 'invoice/RECEIVED_CURRENT_INVOICE_ID';
export const REQUEST_GET_ALL_INVOICE = 'invoice/REQUEST_GET_ALL_INVOICE';
export const RECEIVED_ALL_INVOICE = 'invoice/RECEIVED_ALL_INVOICE';
export const RECEIVED_ERROR = 'invoice/RECEIVED_ERROR';